import { render, staticRenderFns } from "./SalSalesOrderDetail.vue?vue&type=template&id=3bacf610&scoped=true&"
import script from "./SalSalesOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SalSalesOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalSalesOrderDetail.vue?vue&type=style&index=0&id=3bacf610&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bacf610",
  null
  
)

export default component.exports